<div class="custom-calendar-header flex items-center justify-between p-2">
    <div class="flex items-center gap-2">
        <button mat-icon-button (click)="currentPeriodClicked()">
            <mat-icon *ngIf="calendar.currentView === 'month'" svgIcon="arrow-left"></mat-icon>
            <mat-icon *ngIf="calendar.currentView === 'multi-year'" svgIcon="arrow-down"></mat-icon>
        </button>
        <span class="month-year-label">{{ periodButtonText }}</span>
    </div>

    <div class="flex items-center gap-2">
        <button mat-icon-button (click)="previousClicked(calendar.currentView)" color="accent">
            <mat-icon svgIcon="angle-left"></mat-icon>
        </button>
        <button mat-icon-button (click)="nextClicked(calendar.currentView)" color="accent">
            <mat-icon svgIcon="angle-right"></mat-icon>
        </button>
    </div>
</div>
